// extracted by mini-css-extract-plugin
export var container = "diapoPres-module--container--17fec";
export var containerArrow = "diapoPres-module--containerArrow--d44b0";
export var containerImage = "diapoPres-module--containerImage--4fd83";
export var containerText = "diapoPres-module--containerText--f2f43";
export var image = "diapoPres-module--image--47fe4";
export var inLoadContainer = "diapoPres-module--inLoadContainer--17c7e";
export var leftArrowDiaporamaTest = "diapoPres-module--leftArrowDiaporamaTest--b1359";
export var rightArrowDiaporamaTest = "diapoPres-module--rightArrowDiaporamaTest--e3706";
export var root = "diapoPres-module--root--2fd51";
export var shine = "diapoPres-module--shine--1d0ac";
export var svg = "diapoPres-module--svg--a87eb";
export var thumbnailMargin = "diapoPres-module--thumbnailMargin--c42b6";
export var thumbnails = "diapoPres-module--thumbnails--c090d";
export var thumbnailsActive = "diapoPres-module--thumbnailsActive--75942";
export var title = "diapoPres-module--title--49c96";